import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.navbar = document.getElementById("navbar")
    this.update = this.update.bind(this)

    window.addEventListener("scroll", this.update, { passive: true })

    this.resizeObserver = new ResizeObserver(this.update)
    this.resizeObserver.observe(this.element.parentElement)
    if (this.navbar) this.resizeObserver.observe(this.navbar)

    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
    this.resizeObserver.disconnect()
  }

  update() {
    window.requestAnimationFrame(() => {
      const container = this.element.parentElement
      if (!container) return

      const containerRect = container.getBoundingClientRect()
      // When navbar does not exist we want to put flash always on the top
      const navbarHeight = this.navbar ? Math.max(0, Math.min(this.navbar.getBoundingClientRect().bottom, this.navbar.offsetHeight)) : 0

      this.element.style.top = `${navbarHeight}px`
      this.element.style.left = `${containerRect.left}px`
      this.element.style.width = `${containerRect.width}px`
    })
  }
}
